// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface NumberOfKeysHeaderProps {
  bulkChangeNumberOfKeys: (e: unknown) => void;
  bulkNumberOfKeysOnBlur: () => void;
  bulkNumberOfKeys?: string;
}

function NumberOfKeysHeader({
  bulkChangeNumberOfKeys,
  bulkNumberOfKeysOnBlur,
  bulkNumberOfKeys,
}: NumberOfKeysHeaderProps) {
  const { t } = useTranslation();
  return (
    <div className="bulk-grid-game-name-th hidden-input">
      <span className="mb-2 text-right">{t('Number of keys')}</span>
      <input
        type="number"
        className="form-control num"
        onChange={bulkChangeNumberOfKeys}
        onBlur={bulkNumberOfKeysOnBlur}
        value={bulkNumberOfKeys || ''}
        placeholder={t('Apply to all')}
      ></input>
    </div>
  );
}

export default NumberOfKeysHeader;
